import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UtilsService} from "../../../../shared/utils/utils.service";
import {moduloHorasExtras} from "../../diccionarios/horas-extrasModulo";
import {
  LfsaBotonEditarGridComponent
} from "../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import * as _ from 'lodash';
import {ParametrizacionEmpleadoService} from "../../services/parametrizacion-empleado.service";
import {ModalService} from "../../services/modal.service";
import {Row, Workbook as wb, Worksheet} from "exceljs";
import {saveAs} from 'file-saver';
import {ParametrizacionTipoTurnoService} from "../../services/parametrizacion-tipo-turno.service";

@Component({
  selector: 'app-parametrizacion-empleados',
  templateUrl: './parametrizacion-empleados.component.html',
  styleUrls: ['./parametrizacion-empleados.component.css']
})
export class ParametrizacionEmpleadosComponent implements OnInit, AfterViewInit {
  mostrarFormulario: boolean = false;
  mostrarGridLista: boolean = true;
  titulo: string;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formulario: FormGroup;
  loading: boolean = false;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  cmbLocalizaciones: any[];
  cmbTipoTurno: any[];
  cmbTipos: any[];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;
  labelEmpleadoInfo: any;
  obligatorylocality: boolean = false;
  today: any;
  @ViewChild('fileInput') fileInput: ElementRef;
  formularioCargaMasiva: FormGroup;


  workbook: wb;
  data: any = [];
  dataExcel: any = [];
  uploadForm: FormGroup;
  actualWeek: number;

  poseeHS = true;
  poseeHE = true;


  constructor(
    private fb: FormBuilder,
    private _parametrizacionEmpleado: ParametrizacionEmpleadoService,
    private _parametrizacionTipoTurnoService: ParametrizacionTipoTurnoService,
    private _util: UtilsService,
    private _modalService: ModalService
  ) {
    this.diccionarioModulo = moduloHorasExtras;
  }

  ngAfterViewInit(): void {
    this.formularioCargaMasiva = this.fb.group({
      multipart: ['', [Validators.required]],
    });
    this.formulario = this.fb.group({
      id: [''],
      cedula: ['', [Validators.required]],
      tipoCalculo: ['', [Validators.required]],
      horas: ['', [Validators.required]],
      poseeHS: [this.poseeHS],
      poseeHE: [this.poseeHE],
      idTurno: [''],
    });
  }


  ngOnInit(): void {
    this.DAT_BTNS = moduloHorasExtras.button.buttonsNombre;
    this.DAT_TITULOS = moduloHorasExtras.titulos.parametrizacionEmpleados;
    this.DAT_BTNCSS = moduloHorasExtras.button.buttonsCss;
    this.DAT_MSG = moduloHorasExtras.mensajes;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.cmbTipos = [
      {
        id: 1,
        descripcion: "Estatico"
      },
      {
        id: 2,
        descripcion: "Dinamico"
      },
    ];
    this.girdComponent();
    this.getAllParamatrosEmpleados();
    this._modalService.getModalEvent().subscribe(data => {
      if (data && data.data) {
        this.formulario.get('cedula').setValue(data.data.cedula);
        this.labelEmpleadoInfo = data.data.cedula + ' - ' + data.data.nombres
      }
    });
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  nuevo() {
    this.titulo = this.DAT_TITULOS.tituloCardGuardar;
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.guardar;
    this.editableForm = false;
    this.labelEmpleadoInfo = '';
    this.formulario.reset();
    this.getFormInfo();
  }

  getAllParamatrosEmpleados() {
    this.loading = true;
    this._parametrizacionEmpleado.getAll().subscribe((res: any) => {
      this.rowData = res;
      this.loading = false;
    }, () => {
      this.loading = false;
      this.rowData = [];
    });
  }

  cargaMasivaParamatrosEmpleados(file) {
    this.loading = true;
    const formData = new FormData();
    formData.append('file', file);
    this._parametrizacionEmpleado.cargaMasivaParamatrosEmpleados(formData).subscribe((res: any) => {
      this.rowData = res;
      this.getAllParamatrosEmpleados();
      this.loading = false;
    }, (error) => {
      this.loading = false;
      this.rowData = [];
      let errorMensaje = error.error.mensaje + '<br/>';
      let text = '';
      try {
        error.error.respuesta.forEach(errorObject => {
          text = text + '<br/>' + '<br/>' + errorObject;
        });
      } catch (e: any) {
        text = text + '<br/>' + '<br/>' + error.error.respuesta;
      }
      this._util.mensajeErrorVisto(errorMensaje, true, 90000, text);
      this.getAllParamatrosEmpleados();
    });
  }


  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'CEDULA',
        field: 'cedula',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'NOMBRE',
        field: 'empleado.nombres',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: 'TIPO CÁLCULO',
        field: 'tipoCalculo',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'HORAS',
        field: 'horas',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'ID TIPO TURNO',
        field: 'idTurno',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'HS',
        field: 'aplicaHorasSuplementarias',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'HE',
        field: 'aplicaHorasExtraordinarias',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editarEmpleado.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];
    this.rowSelection = 'single';
  }

  editarEmpleado({rowData}) {
    this.titulo = this.DAT_TITULOS.tituloCardEditar;
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.editar;
    this.editableForm = true;
    this.getFormInfo(rowData);
  }

  getFormInfo(rowData?) {
    this.loading = true;
    this._parametrizacionTipoTurnoService.getAll().subscribe((res: any) => {
      this.cmbTipoTurno = res;
      if (this.editableForm) {
        const payload = this.formatData(rowData);
        this.formulario.get('id').setValue(payload.id);
        this.formulario.get('cedula').setValue(payload.cedula);
        this.formulario.get('tipoCalculo').setValue(payload.tipoCalculo);
        this.formulario.get('horas').setValue(payload.horas);
        this.formulario.get('poseeHE').setValue(payload.aplicaHorasExtraordinarias === 'SI');
        this.formulario.get('poseeHS').setValue(payload.aplicaHorasSuplementarias === 'SI');
        this.formulario.get('idTurno').setValue(payload.idTurno);
        this.labelEmpleadoInfo = rowData.cedula + ' - ' + rowData.nombre;
        //this.formulario.setValue(payload);
      }
      this.loading = false;
    }, () => {
      this.loading = false;
      this.cmbTipoTurno = [];
    });
  }


  eliminar({rowData}) {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.eliminar,
        text: ``,
        action: this.DAT_BTNS.eliminar,
        funcion: this._parametrizacionEmpleado.borrarParametrosEmpleado(rowData),
      }
    ).then((res: any) => {
      this.gridApi.updateRowData({remove: this.gridApi.getSelectedRows()});
    });
  }

  formatData(data) {
    let rowData = _.cloneDeep(data);
    if (rowData.tipoCalculo) {
      const tipoCalculo = this.cmbTipos.find(tipo => tipo.descripcion.trim().toLowerCase() === rowData.tipoCalculo.trim().toLowerCase());
      rowData.tipoCalculo = tipoCalculo.id;
    }
    if (rowData.idTurno) {
      const idTurno = this.cmbTipoTurno.find(tipoTurno => tipoTurno.id.trim().toLowerCase() === rowData.idTurno.trim().toLowerCase());
      rowData.idTurno = idTurno.id;
    }
    return rowData;
  }

  acciones(event) {
    //return;
    if (event === 'guardar') {
      if (this.editableForm) {
        this.actualizarParametroEmpleado();
      } else {
        this.guardarEmpleado();
      }
    } else {
      this.titulo = this.DAT_TITULOS.tituloCardListar;
      this.mostrarGridLista = true;
    }
  }

  actualizarParametroEmpleado() {
    const payload = _.cloneDeep(this.formulario.value);
    payload.poseeHS = payload.poseeHS ? 1 : 2;
    payload.poseeHE = payload.poseeHE ? 1 : 2;
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: ``,
        action: this.DAT_BTNS.editar,
        funcion: this._parametrizacionEmpleado.actualizarParametrosEmpleado(payload),
        loading: true,
        context: this
      }
    ).then((res: any) => {
      this.getAllParamatrosEmpleados();
      this.regresar();
    });
  }

  guardarEmpleado() {
    const payload = _.cloneDeep(this.formulario.value);
    payload.poseeHS = payload.poseeHS ? 1 : 2;
    payload.poseeHE = payload.poseeHE ? 1 : 2;
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: ``,
        action: this.DAT_BTNS.guardar,
        funcion: this._parametrizacionEmpleado.guardarParametrosEmpleado([payload]),
        loading: true,
        context: this
      }
    ).then((res: any) => {
      this.getAllParamatrosEmpleados();
      this.regresar();
    });
  }

  regresar() {
    this.formulario.reset();
    this.mostrarGridLista = true;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
  }

  onFileSelect(event) {
    if (event.target.files.length > 0) {
      this.loading = true;
      let allowedExtensions = /(.xlsx)$/i;
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formularioCargaMasiva.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido,  el tipo de archivo permitido es "xlsx" (EXCEL)', true, 9000);
        this.fileInput.nativeElement.value = '';
        this.loading = false;
      } else {
        this.formularioCargaMasiva.get('multipart').setValue(file);
        this.cargaMasivaParamatrosEmpleados(this.formularioCargaMasiva.get('multipart').value);
      }
    }
  }

  openModalEmpleados() {
    document.getElementById('abrirModalEmpleado').click();
  }


  descargarExcel() {
    this.generarEcxel();
  }


  async generarEcxel() {
    this.dataExcel = [];
    this.workbook = new wb();
    this.rowData.forEach(x => {
      if (!x.empleado){
        return;
      }
      let payload = {
        cedula: x.cedula,
        nombre: x.empleado.nombres,
        cargo: x.empleado.dscaCargo,
        departamento: x.empleado.dscaDepartamento,
        localidad: x.empleado.dscaLocalidad,
        centroCosto: x.empleado.dscaCentroCosto,
        tipoCalculo: x.tipoCalculo,
        horas: x.horas,
        tipoTurno: x.idTurno,
        isHS: x.aplicaHorasSuplementarias,
        isHE: x.aplicaHorasExtraordinarias,
      };
      this.dataExcel.push(payload);
    });
    this.fillExcelMarketplace();
    await this.workbook.xlsx.writeBuffer().then(data => {
      const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      saveAs(blob, 'parametrizacion-empleados' + '.xlsx');
    });
  }

  fillExcelMarketplace() {
    const nameSheet = 'Parametrización de empleados';
    let header;

    header = [
      'Cédula',
      'Colaborador',
      'Cargo',
      'Departamento',
      'Localidad',
      'Centro Costo',
      'TIPO CALCULO',
      'HORAS',
      'ID TIPO TURNO',
      'APLICA HS',
      'APLICA HE',
    ];
    let row;
    let headerRow;

    const worksheet = this.workbook.addWorksheet(nameSheet, {
      pageSetup: {
        horizontalCentered: true,
        verticalCentered: true,
        paperSize: 9,
        orientation: 'portrait',
        margins: {
          left: 0.3149606,
          right: 0.3149606,
          top: 0.3543307,
          bottom: 0.3543307,
          header: 0.3149606,
          footer: 0.3149606,
        },
      },
    });
    row = worksheet.getRow(0);
    headerRow = worksheet.addRow(header);
    headerRow.height = 25;

    worksheet.columns[0].width = 15;
    worksheet.columns[1].width = 40;
    worksheet.columns[2].width = 40;
    worksheet.columns[3].width = 40;
    worksheet.columns[4].width = 10;
    worksheet.columns[5].width = 40;
    worksheet.columns[6].width = 15;
    worksheet.columns[7].width = 10;
    worksheet.columns[8].width = 10;
    worksheet.columns[9].width = 10;
    worksheet.columns[10].width = 10;

    worksheet.eachRow(function (RowP, rowNum) {
      RowP.eachCell(function (Cell, cellNum) {
        Cell.alignment = {
          vertical: 'middle',
          horizontal: 'right',
        };
      });
    });

    this.data = this.formatDataExcel();

    this.fillRows(worksheet);

    this.formatWorksheet(worksheet, headerRow);
  }

  fillRows(worksheet: Worksheet) {
    for (const x1 of this.data) {
      const x2 = Object.keys(x1);
      const temp = [];
      for (const y of x2) {
        temp.push(x1[y]);
      }
      worksheet.addRow(temp);
    }
  }

  formatWorksheet(worksheet: Worksheet, headerRow: Row) {
    worksheet.eachRow(function (Rowt, rowNum) {
      Rowt.eachCell(function (cell, cellNum) {
        if (rowNum === headerRow.number) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: '1aa798'},
            bgColor: {argb: 'FF0000FF'},
          };
          cell.border = {
            top: {style: 'thin'},
            left: {style: 'thin'},
            bottom: {style: 'thin'},
            right: {style: 'thin'},
          };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
          cell.font = {
            bold: true,
          };
        } else {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }
      });
    });
  }

  formatDataExcel(n?: any) {
    this.data = [];
    switch (true) {
      default: {
        this.data = this.dataExcel;
        break;
      }
    }

    return this.data;
  }


}
